<template>
  <div class="extracted-details">
    <!-- VAT Statement Details -->
    <VATStatementDetails 
      v-if="fileType === 'vat_statement' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- Trade License Details -->
    <TradeLicenseDetails 
      v-else-if="fileType === 'trade_license' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- Emirates ID Details -->
    <EmiratesIDDetails 
      v-else-if="fileType === 'emirates_id' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- Bank Statement Details -->
    <BankStatementDetails 
      v-else-if="fileType === 'bank_statement' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- AECB Report Details -->
    <AECBReportDetails 
      v-else-if="fileType === 'aecb_report' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- Payer List Details -->
    <PayerListDetails 
      v-else-if="fileType === 'payer_list' && processedExtractedData"
      :data="processedExtractedData"
    />

    <!-- No Data Message -->
    <div v-else-if="!processedExtractedData" class="no-data">
      <div class="no-data-icon">
        <i class="las la-file-alt"></i>
      </div>
      <h3>No Extracted Data</h3>
      <p>No extracted details are available for this file type.</p>
    </div>
  </div>
</template>

<script>
import {
  VATStatementDetails,
  TradeLicenseDetails,
  EmiratesIDDetails,
  BankStatementDetails,
  AECBReportDetails,
  PayerListDetails
} from './extracted-details'

export default {
  name: 'ExtractedDetails',
  components: {
    VATStatementDetails,
    TradeLicenseDetails,
    EmiratesIDDetails,
    BankStatementDetails,
    AECBReportDetails,
    PayerListDetails
  },
  props: {
    fileType: {
      type: String,
      required: true
    },
    extractedData: {
      type: Array,
      default: null
    }
  },
  computed: {
    processedExtractedData() {
      if (!this.extractedData) return null;
      
      // For most file types, the data is in the first element of the array
      if (Array.isArray(this.extractedData)) {
        return this.extractedData[0];
      }
      
      return this.extractedData;
    }
  },
  mounted() {
    console.log('extractedData', this.extractedData);
    console.log('processedExtractedData', this.processedExtractedData);
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';

.extracted-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  
  .no-data-icon {
    font-size: 3rem;
    color: #adb5bd;
    margin-bottom: 1rem;
  }
  
  h3 {
    color: #6c757d;
    margin: 0 0 0.5rem 0;
    font-size: 1.2rem;
    font-family: $brand-font-medium;
  }
  
  p {
    color: #adb5bd;
    margin: 0;
    font-family: $brand-font-regular;
  }
}
</style>
